import { Component, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { SmtpConfig } from "../core/model/smtp-config";
import { SmtpConfigService } from "../core/service/smtp-config.service";
import { EditSmtpConfigComponent } from "./edit-smtp-config/edit-smtp-config.component";
import { AddSmtpConfigComponent } from "./add-smtp-config/add-smtp-config.component";

@Component({
  selector: "app-smtp-config",
  templateUrl: "./smtp-config.component.html",
  styleUrls: ["./smtp-config.component.scss"],
})
export class SmtpConfigComponent implements OnInit {
  smtps: SmtpConfig[];

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _smtpConfigService: SmtpConfigService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.getAllSmtps();
  }

  getAllSmtps() {
    this._smtpConfigService.getAllSmtps().subscribe(
      (data) => {
        this.smtps = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  edit(smtp: SmtpConfig): void {
    const modalRef = this.modalService.open(EditSmtpConfigComponent, {
      centered: true,
    });
    modalRef.componentInstance.smtp = smtp;

    modalRef.result.then(
      (updated: SmtpConfig) => {
        if (updated && this.smtps) {
          const index = this.smtps.findIndex((s) => s.id === updated.id);
          if (index !== -1) {
            this.smtps[index] = updated;
            this.smtps = [...this.smtps];
            return;
          }
        }
        this.getAllSmtps();
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  add(): void {
    const modalRef = this.modalService.open(AddSmtpConfigComponent, {
      centered: true,
    });

    modalRef.result.then(
      (data) => {
        // on close
        this.getAllSmtps();
      },
      (reason) => {
        // on dismiss
      }
    );
  }
}
